/*
 * @Author: dongzhuo
 * @Date: 2021-01-04 09:25:47
 * @Description: store 值计算
 */
//  获取boolean值存储
const getBooleanData = val => {
  if (val == "true") {
    return true;
  } else if (val == "false") {
    return false;
  } else {
    return val;
  }
};
const getters = {

  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userMenu: state => state.user.userMenu,
  loginType: state => state.user.loginType,
  user: state => state.user.userInfo.user,
  resume: state => state.user.userInfo.resume,
  isResume: state => getBooleanData(state.user.userInfo.isResume),
  userId: state => state.user.userInfo.user.user_id,
  userName: state => state.user.userInfo.user.user_name,
  userPhone: state => state.user.userInfo.user.mobile,
  weChatID: state => state.user.weChatID,
  

};
export default getters;
